<template>
	<div class="index_header" v-loading="loading">
		 <div class="header1_box">
            <div class="header1">
                <div class="lefts" v-if="!vuex_user.name">
                    <div class="l_text1" @click="handle_logo">
                        您好，请登录
                    </div>
                    <div class="l_text2" @click="handle_enroll">
                        注册
                    </div>
                </div>
                <div class="lefts" v-if="vuex_user.name">        
                    <div class="l_text1" @click="handle_user">
                        您好，{{ vuex_user.name }}
                    </div>            
                </div>
                <div class="rights">
                    <div class="r_text1" @click="handle_home">首页</div>
                    <div class="r_text2">
                        <el-dropdown  @command="handle_hyzx">
                            <span class="el-dropdown-link" >
                                会员中心<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item  :command="item" v-for="(item,index) in hyzx_list" :key="index">{{ item.title }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="r_text2">
                        <el-dropdown  @command="handle_ksfb">
                            <span class="el-dropdown-link" >
                                快速发布<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item  :command="item" v-for="(item,index) in ksfb_list" :key="index">{{ item.title }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="r_text2">
                        <el-dropdown  @command="handle_wzdh">
                            <span class="el-dropdown-link" >
                                网站导航<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item  :command="item" v-for="(item,index) in wzdh_list" :key="index">{{ item.title }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    
                </div>
            </div>
          
         </div>
         <div class="header2_box">
                <div class="header2_top">
                    <div class="lefts">
                        <div class="logos">
                            <img :src="vuex_setting.site_logo" alt=""  @click="handle_home">
                            
                        </div>
                    </div>
                    <div class="const">
                        <div class="seach_box">
                            <div class="inputs">
                                <input type="text" placeholder="请输入关键字" v-model="keyword">
                            </div>
                            <div class="btns" @click="handle_keyword">
                                <img src="@/assets/img/component/header/seach.png" alt="" >
                                搜索
                            </div>
                        </div>
                    </div>
                    <div class="rights">
                        <div class="r_phones">
                            <div class="imgs">
                                <img src="@/assets/img/component/header/phone.png" alt="">
                            </div>
                            <div class="r_text_box">
                                <div class="text1">客服热线</div>
                                <div class="text2">{{ vuex_setting.site_tel||'' }}</div>
                            </div>
                        </div>
                        <div class="kf_btns">
                            <img src="@/assets/img/component/header/kf_icon.png" alt="">
                            在线客服
                        </div>
                    </div>
                </div>
                <div class="header2_bom">
                    <div class="header2">
                        <div class="tab_list" v-for="(item,index) in tab_list" :key="index">
                            <!-- tab_item1_ac -->
                             <!-- {{ tab_ac }} -->
                            <div class="tab_item1" :class="{tab_item1_ac:item.path_ac.indexOf(tab_ac)>-1}" v-if="item.list.length==0" @click="handle_path(item)">
                                {{ item.title }}
                                <div class="borders"></div>
                            </div>
                            <div class="tab_item2" :class="{tab_item1_ac:item.path_ac.indexOf(tab_ac)>-1}" v-if="item.list.length>0">
                                <el-dropdown  @command="handle_tab">
                                    <span class="el-dropdown-link" >
                                        <!-- <div class=""> -->
                                            <div>
                                                {{ item.title }}
                                                <div class="borders"></div>
                                            </div>
                                            <div>
                                                <i class="el-icon-arrow-down el-icon--right"></i>
                                            </div>
                                        <!-- </div> -->
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item  :command="items" v-for="(items,indexs) in item.list" :key="indexs">{{ items.title }}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
	export default {
		components: {

		},
		name: "index",
		data() {
			return {
                loading:false,
                // 个人中心：个人信息、我的订单、我的点评、我的委托
                // 会员中心菜单列表
                hyzx_list:[
                    {
                        title:'个人信息',
                        path:'/user_grzx'
                    },
                    {
                        title:'我的订单',
                        path:'/user_order'
                    },
                    {
                        title:'我的点评',
                        path:'/user_dp'
                    },
                    {
                        title:'我的委托',
                        path:'/user_wt'
                    },
                    {
                        title:'退出登录',
                        path:''
                    },
                ],
                //快速发布
                // 快速发布：发布案例点评、发布委托
                ksfb_list:[
                    {
                        title:'发布案例点评',
                        path:'/release_index'
                    },
                    {
                        title:'发布委托',
                        path:'/enterprise_list'
                    }
                ],
                //网站导航
                // 网站导航：帮助中心
                wzdh_list:[
                    {
                        title:'帮助中心',
                        path:'/index'
                    }
                ],
                tab_ac:'',
                tab_list:[
                    {
                        title:'首页',
                        path:'/home',
                        list:[],
                        path_ac:[
                            'home',
                        ]
                    },
                    {
                        title:'法律咨询',
                        path:'/online',
                        list:[
                            {
                                title:'在线咨询',
                                path:'/online'
                            },
                            {
                                title:'预约律师',
                                path:'/lawyer_list'
                            },
                        ],
                        path_ac:[
                            'online',
                            'online_quitting',
                            'lawyer_list',
                            'lawyer_detial',
                            'lawyer_sever_list',
                        ]
                    },
                    {
                        title:'裁判点评',
                        path:'/comments_list',
                        list:[
                            {
                                title:'裁判点评',
                                path:'/comments_list'
                            },
                            {
                                title:'案例库',
                                path:'/case_list'
                            },
                            {
                                title:'案例发布',
                                path:'/release_index'
                            }
                        ],
                        path_ac:[
                            'comments_list',
                            'comments_detial',
                            'case_list',
                            'case_detial',
                            'release_index',
                            
                        ]
                    },
                    {
                        title:'案源广场',
                        path:'/square_list',
                        list:[],
                        path_ac:[
                            'square_list',
                            'square_detial',
                        ]
                       
                    },
                    {
                        title:'企业法务',
                        path:'/enterprise_list',
                        list:[],
                        path_ac:[
                            'enterprise_list',
                            'enterprise_detial',
                        ]
                    },
                    {
                        title:'个人法务',
                        path:'/individual_list',
                        list:[],
                        path_ac:[
                            'individual_list',
                            'individual_detial',
                        ]
                    },
                    {
                        title:'法律讲堂',
                        path:'/Classroom',
                        list:[
                            {
                                title:'法律讲堂',
                                path:'/Classroom'
                            },
                            {
                                title:'法界热点',
                                path:'/hot_spot'
                            },
                            {
                                title:'人才招聘',
                                path:'/talent_acquisition'
                            }
                        ],
                        path_ac:[
                            'Classroom',
                            'Classroom_list_video',
                            'Classroom_list_video_detial',
                            'Classroom_list_text',
                            'Classroom_list_text_detial',
                            'hot_spot',
                            'hot_spot_type',
                            'hot_spot_type_detial',
                            'talent_acquisition',
                            'talent_acquisition_detial',
                        ]
                    },
                    {
                        title:'招商加盟',
                        path:'/index',
                        list:[
                            {
                                title:'招商加盟',
                                path:'/Merchants'
                            },
                            {
                                title:'区域合伙人',
                                path:'/Regional_Partner'
                            }
                        ],
                        path_ac:[
                            'Merchants',
                            'Regional_Partner',
                        ]
                    },
                    {
                        title:'更多服务',
                        path:'/index',
                        list:[
                            {
                                title:'诉讼费计算器',
                                path:'/service?type=1'
                            },
                            {
                                title:'服务报价计算器',
                                path:'/service?type=2'
                            },
                            {
                                title:'点评服务费',
                                path:'/service?type=3'
                            },
                            {
                                title:'积分商城',
                                path:'/shop'
                            }
                        ],
                        path_ac:[
                            'service',
                            'shop',
                        ]
                    }
                    
                ],
                keyword:'',
			}
		},
		computed: {
			...mapState(['vuex_setting','vuex_user'])
		},
		watch: {
            // tab_ac
            $route:{
                handler(newVal, oldVal) {
                    console.log(newVal)
                    this.tab_ac=newVal.path.split('/')[1]
            
                },
                immediate: true,
                deep: true
            },
		},
		created() {
			 
		},
		methods: {
            handle_keyword(){
                this.$router.push({
                    path:'/square_list',
                    query:{
                        keyword:this.keyword
                    }
                })
            },
            // 会员中心点击
            handle_hyzx(e){
                console.log('会员中心点击',e)
                if(e.title=='退出登录'){
                    this.$confirm('是否退出?', '提示', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning'
                    }).then(() => {
					    this.$store.commit('clear_vuex_user',{})
                    }).catch(() => {
                                
                    });

                    
                }else{
                    this.$router.push({
                        path:e.path
                    })
                }
            },
            //快速发布
            handle_ksfb(e){
                console.log('快速发布点击',e)
                this.$router.push({
                    path:e.path
                })
            },
            //网站导航
            handle_wzdh(e){
                console.log('网站导航点击',e)
                this.$router.push({
                    path:e.path
                })
            },
            //底部跳转
            handle_path(item){
                console.log('底部跳转点击',item)
                this.$router.push({
                    path:item.path,
                })

            },
            //底部下拉跳转
            handle_tab(e){
                console.log('底部下拉跳转',e)
                this.$router.push({
                    path:e.path,
                })
            },
           
            handle_user(){
                this.$router.push({
                    path:'/user_grzx'
                })
            },
            handle_logo(){
                this.$router.push({
                    path:'/login'
                })
            },
            handle_enroll(){
                this.$router.push({
                    path:'/enroll'
                })
            },
            handle_home(){
                this.$router.push({
                    path:'/home'
                })
            },

		},
        

	}
</script>
<style scoped lang="less">
.index_header { 
    width: 100%;
    .header1_box{
        width: 100%;
        height: 40px;
        background: #F7F7F7;
        border-radius: 0px 0px 0px 0px;
        .header1{
            width: 1440px;
            height: 40px;
            margin: auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .lefts{
                display: flex;
                align-items: center;
                .l_text1{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #666666;
                    cursor: pointer;
                }
                .l_text2{
                    cursor: pointer;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #377CFD;
                    margin-left: 24px;
                }
            }
            .rights{
                display: flex;
                align-items: center;
                .r_text1{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #666666;
                    cursor: pointer;
                }
                .r_text2{
                    margin-left: 40px;
                    cursor: pointer;
                }
            }
        }
    }
    .header2_box{
        width: 100%;
        height: 134px;
        background: #FFFFFF;
        box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.1);
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        justify-content: center;
        .header2_top{
            width: 1440px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: auto;
            padding-top: 16px;
            .lefts{
                .logos{
                    width: 275px;
                    height: 64px;
                    img{
                        width: 275px;
                        height: 64px;
                        vertical-align: top;
                        cursor: pointer;
                    }
 
                }
            }
            .const{
                .seach_box{
                    width: 482px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 20px 20px 20px 20px;
                    border: 1px solid #377CFD;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .inputs{
                        flex: 1;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        input{
                            width: 100%;
                            padding: 0 24px;
                        }
                        input::placeholder{
                            color:#D7D7D7;

                        }   

                    }
                    .btns{
                        width: 124px;
                        height: 40px;
                        background: #377CFD;
                        border-radius: 0px 20px 20px 0px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;

                        img{
                            width:18px ;
                            height: 18px;
                            margin-right: 15px;
                        }
                    }

                }
            }
            .rights{
                // width: 400px;
                display: flex;
                align-items: center;
                .r_phones{
                    display: flex;
                    align-items: center;
                    .imgs{
                        width: 48px;
                        height: 48px;
                        img{
                            width: 48px;
                            height: 48px;
                        }
                    }
                    .r_text_box{
                        width: 200px;
                        height: 48px;
                        padding-left: 8px;
                        display: flex;
                        align-content: space-between;
                        flex-wrap: wrap;
                        .text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-size: 14px;
                            color: #666666;
                        }
                        .text2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 20px;
                            color: #377CFD;
                        }

                    }
                }
                .kf_btns{
                    width: 130px;
                    height: 40px;
                    background: #FFAA00;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #FFFFFF;
                    border-radius: 30px;
                    img{
                        width: 22px;
                        height: 22px;
                        margin-right: 11px;
                    }
                }
            }
        }
        .header2_bom{
            .header2{
                width: 1440px;
                margin: auto;
                display: flex;
                align-items: center;
                justify-content: space-between;
                // padding: 0 64px 0 34px ;
                .tab_list{
                    .borders{
                        margin: auto;
                        width: 32px;
                        height: 4px;
                        border-radius: 30px;
                        background: #FFFFFF;

                        margin-top: 10px;
                    }
                    .borders_ac{
                        background: #377CFD;

                    }
                    .tab_item1{
                        width: 70px;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;
                        text-align: center;
                        &:hover{
                            color: #377CFD;
                            // font-weight: bold;
                            .borders{
                                background: #377CFD;
                            }
                        }   
                    }
                 
                    .tab_item2{
                        width: 100px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        /deep/.el-dropdown{
                            .el-dropdown-link{
                                // text-align: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;
                                display:flex;
                                .el-icon-arrow-down{
                                    font-weight: bold;
                                }
                                // align-items: center;
                                &:hover{
                                    color: #377CFD;
                                    // font-weight: bold;
                                    .el-icon-arrow-down{
                                        color: #377CFD;
                                    }
                                    .borders{
                                        background: #377CFD;
                                    }
                                } 
                            }
                        }

                    }
                    .tab_item1_ac{
                        color: #377CFD;
                        // font-weight: bold;
                        .borders{
                            background: #377CFD;
                        }
                        /deep/.el-dropdown{
                            .el-dropdown-link{
                                color: #377CFD;
                                // font-weight: bold;
                                .el-icon-arrow-down{
                                    color: #377CFD;
                                }
                                .borders{
                                    background: #377CFD;
                                }
                            }
                        }
                    }
                  
                }
            }
        }
    }
    
}
</style>